<template>
    <div class="box-page">
        <div class="page-header with-underline">
            <div class="d-flex align-items-center justify-content-center">
                <span class="page-title">ต่ออายุสมาชิก</span>
            </div>
        </div>

        <div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group form-goobank">
                        <label for="renewDateInput" style="order:0">โปรดเลือกวันหมดอายุครั้งถัดไป</label>
                        <v-date-picker v-model="member.renewDate" locale="th" buddhist :popover="{ placement: 'bottom', visibility: 'click' }">
                            <input ref="renewDateInput" id="renewDateInput" name="renewDateInput" class="form-control" :value="renewDateDisplay" placeholder="กรุณาเลือกวันหมดอายุ" @keydown.prevent="" autocomplete="off"
                            :class="{ 'is-valid': (fields.renewDateInput && fields.renewDateInput.dirty) && !errors.has('renewDateInput'), 'is-invalid': errors.has('renewDateInput') }"
                            />
                        </v-date-picker>
                        <div v-show="errors.has('renewDateInput')" class="invalid-feedback" style="display:block"></div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group form-goobank">
                        <div style="margin:20px auto; width:200px;">
                            <div class="custom-control custom-checkbox" @click="toggleMemberLifetime">
                                <input class="custom-control-input" :class="{ 'is-invalid': errors.has('isMemberLifeTime') }" type="checkbox" v-model="isMemberLifeTime"/>
                                <label class="custom-control-label text-secondary" for="isMemberLifeTime">สมาชิกตลอดชีพ ?</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="text-center mt-3">
                <button class="btn btn-small" @click="hideRenewDetail">ย้อนกลับ</button>
                <button class="btn btn-small" @click="updateRenewMember">บันทึก</button>
            </div>
        </div>
    
        <div class="modal-group">

        </div>
    </div>

    
</template>

<script>
import ShareFunction from '../../../share-function';
import dateFormat from '../../../components/utils/date.js';

export default {
    data: function () {
        return {
            isMemberLifeTime: true,
            member: {
                id: null,
                renewDate: '',
            },
            cloneMember: {},
        };
    },
    created: function() {

    },
    computed: {
        renewDateDisplay () {
            if(this.member.renewDate) {
                this.isMemberLifeTime = false;
                return dateFormat.thaidate(this.member.renewDate);
            } else {
                this.isMemberLifeTime = true;
                return '';
            }
        },
    },
    methods: {
        toggleMemberLifetime() {
            this.isMemberLifeTime = !this.isMemberLifeTime;
            if(this.isMemberLifeTime) {
                this.member.renewDate = null;
            }
            return false;
        },
        showMemberRenewDetail(memberID) {
            this.member.id = memberID;
            const params = {
                memberID: this.member.id,
            };
            return axios.post(`${this.baseUrl}/admin/api/get-member-renew-detail`, params).then(({ data }) => {
                if (data != null && data.data) {
                    const d = data.data;

                    // This is important
                    if(d.renew_date == null) {
                        this.member.renewDate = null;
                        this.isMemberLifeTime = true;
                    } else {
                        this.member.renewDate = moment(d.renew_date).toDate();
                        this.isMemberLifeTime = false;
                    }

                    this.cloneMember = Object.assign({}, this.member);
                }
            });
        },
        hideRenewDetail(isLoadList = false) {
            this.$emit('hideRenewDetail', isLoadList);
        },
        getFullPathImage(filename) {
            let result = '/goobank_assets/common/img/avatar.png';
            if (filename) {
                result = `${this.baseUrl}/${this.storagePath}${filename}`;
            }
            return result;
        },
        openImg(src) {
            ShareFunction.openImg(src);
        },
        updateRenewMember() {
            let params = {
                id: this.member.id,
                renew_date: this.member.renewDate,
                isMemberLifeTime: this.isMemberLifeTime
            };
            Object.keys(this.member).forEach(key => {
                if (this.member[key] != this.cloneMember[key]) {
                    params[key] = this.member[key];
                }
            });
            return axios.post(`${this.baseUrl}/admin/api/update-renew-member`, params).then(({ data }) => {
                if (data.success === true) {
                    alertbox('บันทึกสำเร็จ');
                    this.hideRenewDetail(true);
                }
            });
        },
    },
    props: {
        baseUrl: '',
        storagePath: '',
        readOnly: false,
    },
}

</script>
<style lang="scss" scoped>
    .img-member {
        width: 200px;
        height: 200px;
    }
    .img-radius {
        border-radius: 50%;
    }
</style>
